export default "__VITE_ASSET__BsWC8bcC__"